export default __webpack_public_path__ + "static/media/menu2.ac9323c7.svg";